import { StorageKeys } from '../constants/StorageKeys';
import { StopReportCreate } from '../domain/report/StopReportCreate';
import { StorageService, storageService } from './StorageService';

export interface PendingReportCreate {
  id: string;
  data: StopReportCreate;
  error?: string;
}

export class ReportQueueService {
  constructor(private storageService: StorageService) {}

  async addReport(report: StopReportCreate) {
    const reports = await this.getPendingReports();
    const newReport: PendingReportCreate = {
      id: report.stopId,
      data: report,
    };
    const updatedReports = [...reports, newReport];

    await this.storageService.setItem({ key: StorageKeys.REPORTS_QUEUE, item: JSON.stringify(updatedReports) });
  }

  async getPendingReports(): Promise<PendingReportCreate[]> {
    const reports = await this.storageService.getItem({ key: StorageKeys.REPORTS_QUEUE });
    if (!reports) {
      return [];
    }
    const pendingReports = JSON.parse(reports);
    return pendingReports.map((report: any) => {
      const reportId = report._id;
      const projectFields = report.data._projectFields;
      const reportData = report.data.props;
      return {
        ...report,
        data: StopReportCreate.create(reportData, projectFields, reportId),
      };
    }) as PendingReportCreate[];
  }

  async getPendingReport(id: string): Promise<PendingReportCreate | undefined> {
    const reports = await this.getPendingReports();
    return reports.find((t) => t.id === id);
  }

  async removeReport(id: string) {
    const reports = await this.getPendingReports();
    const filtered = reports.filter((t) => t.id !== id);
    await this.storageService.setItem({ key: StorageKeys.REPORTS_QUEUE, item: JSON.stringify(filtered) });
  }

  async clearReports() {
    await this.storageService.removeItem({ key: StorageKeys.REPORTS_QUEUE });
  }

  async updateReportError(id: string, error?: string) {
    const reports = await this.getPendingReports();
    const updated = reports.map((t) => (t.id === id ? { ...t, error } : t));
    await this.storageService.setItem({ key: StorageKeys.REPORTS_QUEUE, item: JSON.stringify(updated) });
  }
}

export const reportQueueService = new ReportQueueService(storageService);
